angular.module('elfium').controller('navbarController', ['$rootScope', '$scope', '$window', 'elfiumLoginService', 'elfiumToastrService', 'ELFIUM_ROUTE_LABELS',
    function ($rootScope, $scope, $window, elfiumLoginService, elfiumToastrService, ELFIUM_ROUTE_LABELS) {
        var that = this;
        that.redirectToLoginPage = function () {
            $window.location = '#/login';
        };
        $scope.currentPageLabel = ELFIUM_ROUTE_LABELS[$window.location.hash.substring(1)];
        $scope.getUserName = function () {
            return elfiumLoginService.getUserName();
        };
        $scope.isUserLoggedIn = function () {
            return elfiumLoginService.isUserLoggedIn();
        };
        $scope.register = function ($event) {
            $event.preventDefault();
            $window.location = '#/register';
        };
        $scope.logout = function ($event) {
            $event.preventDefault();
            elfiumLoginService.sendLogoutRequest().then(that.redirectToLoginPage, elfiumToastrService.error);
        };
        $scope.list = function ($event) {
            $event.preventDefault();
            $window.location = '#/list';
        };
        $scope.isUserAdmin = function () {
            return elfiumLoginService.isUserAdmin();
        };
        $rootScope.$on('$routeChangeSuccess', function (event, current) {
            if (current.$$route) {
                $scope.currentPageLabel = ELFIUM_ROUTE_LABELS[current.$$route.originalPath];
            }
        });
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/navbar/navbarController.ts